module.exports = __webpack_public_path__ + "41f10a6be9160f3dd8ddc7cb2e3d344f.png";